import { useEffect, useState } from "react";
import { CandleSeries } from "../engine";
import { useReplay } from "../context/ReplayContext";

export function useChartData(symbol, tf) {
  const [state, setState] = useState({ candles: [], loading: true });
  const { sessionKey } = useReplay();

  useEffect(() => {
    setState({ candles: [], loading: true });
    const series = new CandleSeries(symbol, tf);
    const off = series.onChange((candles, loading) => setState({ candles, loading }));
    return () => { off(); series.destroy(); };
  }, [symbol, tf, sessionKey]);

  const { candles, loading } = state;
  const lastPrice = candles.length ? candles[candles.length - 1].close : null;
  return { candles, loading, lastPrice };
}
